import Admin from "src/types/Admin.type";
import hasCompany from "./hasCompany";
import hasPendingInvites from "./hasPendingInvites";

const hasRealCompany = (user?: Admin): boolean => {
  return hasCompany(user) || hasPendingInvites(user);
};

export default hasRealCompany;
